module.exports = __webpack_public_path__ + "img/img26.9a43fc47.svg";